export const ambiente = {
  producao: { codigo: "producao" },
  homologacao: { codigo: "homologacao" },
  rollout: { codigo: "rollout" },
  desenvolvimento: { codigo: "desenvolvimento" },
  local: { codigo: 'local' }
};

export const unidadeFederativa = [
  { codigo: "AC", descricao: "AC" },
  { codigo: "AL", descricao: "AL" },
  { codigo: "AP", descricao: "AP" },
  { codigo: "AM", descricao: "AM" },
  { codigo: "BA", descricao: "BA" },
  { codigo: "CE", descricao: "CE" },
  { codigo: "DF", descricao: "DF" },
  { codigo: "ES", descricao: "ES" },
  { codigo: "GO", descricao: "GO" },
  { codigo: "MA", descricao: "MA" },
  { codigo: "MT", descricao: "MT" },
  { codigo: "MS", descricao: "MS" },
  { codigo: "MG", descricao: "MG" },
  { codigo: "PA", descricao: "PA" },
  { codigo: "PB", descricao: "PB" },
  { codigo: "PR", descricao: "PR" },
  { codigo: "PE", descricao: "PE" },
  { codigo: "PI", descricao: "PI" },
  { codigo: "RJ", descricao: "RJ" },
  { codigo: "RN", descricao: "RN" },
  { codigo: "RS", descricao: "RS" },
  { codigo: "RO", descricao: "RO" },
  { codigo: "RR", descricao: "RR" },
  { codigo: "SC", descricao: "SC" },
  { codigo: "SP", descricao: "SP" },
  { codigo: "SE", descricao: "SE" },
  { codigo: "TO", descricao: "TO" },
];

export const sexos = [
  { codigo: "F", descricao: "Feminino" },
  { codigo: "M", descricao: "Masculino" }
]

export const statusAmostra = {
  naoRecebido: "Não recebido",
  recebido: "Recebido",
  excluida: "Excluída"
}